import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;

  inset: 0;

  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
`

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  height: 100vh;

  animation: from-below 0.3s ease forwards;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  @media only screen and (min-width: 800px) {
    left: unset;

    animation: from-right 0.3s ease forwards;
  }

  @keyframes from-below {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes from-right {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`

export const Content = styled.div<{ $innerHeight: number }>`
  background-color: ${({ theme }) => (theme.isDark ? '#222' : '#fff')};

  min-height: ${({ $innerHeight }) => $innerHeight}px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 24px 20px;

    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;

      color: ${({ theme }) => theme.background.low};
    }

    .close {
      color: rgb(${({ theme }) => theme.primary.base});

      font-size: 14px;
      font-weight: 500;
      line-height: 130%;

      padding: 10px 16px;

      background: none;
      border: none;
    }
  }

  .scrollable {
    overflow-y: auto;
    height: calc(${({ $innerHeight }) => $innerHeight}px - 90px);
  }

  .filters {
    display: flex;
    flex-direction: column;
    gap: 18px;

    padding: 14px 24px;

    background-color: ${({ theme }) => (theme.isDark ? '#2C2C2C' : '#F9F9F9')};

    .group {
      display: flex;
      gap: 40px;
      align-items: center;

      .label {
        color: ${({ theme }) => (theme.isDark ? '#BABABA' : '#808080')};

        font-size: 14px;
        font-weight: 600;
        line-height: 130%;
      }

      .text-dropdown {
        flex-grow: 1;

        .text-dropdown--button-area {
          padding: 10px 20px;

          border: ${({ theme }) => `1px solid ${theme.isDark ? '#595959' : '#D0D5DD'}`};
          background-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#fff')};

          font-weight: 500;
        }

        .text-dropdown--button-label,
        .text-dropdown--dropdown-label {
          font-weight: 500;
        }
      }
    }
  }

  .list {
    .loading {
      display: flex;
      padding: 30px 22px;
      flex-direction: column;
      gap: 20px;

      .loading-block {
        height: 320px;
      }
    }

    .footer {
      padding: 36px 22px;

      .load-more {
        border-radius: 4px;
        border-width: 1px;
        border-style: solid;
        border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

        background: none;

        color: ${({ theme }) => `rgb(${theme.primary.base})`};

        width: 100%;

        padding: 12px 0;

        font-size: 14px;
        font-weight: 600;
        line-height: 18px;

        :disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      }
    }
  }

  @media only screen and (min-width: 800px) {
    width: 560px;

    .header {
      padding: 44px 32px 32px;

      .title {
        font-size: 22px;
      }
    }

    .scrollable {
      height: calc(${({ $innerHeight }) => $innerHeight}px - 115px);
    }

    .filters {
      padding: 30px;

      .group {
        .text-dropdown {
          max-width: 220px;
        }
      }
    }

    .list {
      .loading {
        .loading-block {
          height: 250px;
        }
      }
    }
  }
`

export const SearchBar = styled.label`
  border-radius: 4px;
  width: 100%;

  padding: 15px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ theme }) => `1px solid ${theme.isDark ? '#595959' : '#D0D5DD'}`};

  background-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#fff')};
  color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')};

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  input {
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    width: 100%;
    font-size: 14px;

    &::placeholder {
      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
    }
  }
`
